import { render, staticRenderFns } from "./ProofOfEmployerAddress.vue?vue&type=template&id=112c9861&"
import script from "./ProofOfEmployerAddress.vue?vue&type=script&lang=js&"
export * from "./ProofOfEmployerAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports